import styled from 'styled-components';
export var ModalContent = styled.div.withConfig({
  displayName: "ModalContent",
  componentId: "sc-1x0pqif-0"
})(["display:flex;flex-flow:column;height:100vh;padding:40px 16px 14px;"]);